@if(incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup" (change)="saveForm()">
    <snelstart-ui-number-form-control
      formControlName="voorlopigeAanslag"
      label="Voorlopige aanslag(en) IB {{ (incomeTaxEntity$ | async)?.year}}"
      id="voorlopigeAanslag"
      class="custom-input-250"
      [decimals]="0"
      align="right"
      prefix="€"
      [disabledControl]="(formGroup.get('voorlopigeTeruggave')?.value ?? 0) !== 0"
    >
    </snelstart-ui-number-form-control>
    <snelstart-ui-number-form-control
      formControlName="voorlopigeTeruggave"
      label="Voorlopige teruggave(n) IB {{ (incomeTaxEntity$ | async)?.year}}"
      id="voorlopigeTeruggave"
      class="custom-input-250"
      [decimals]="0"
      [disabledControl]="(formGroup.get('voorlopigeAanslag')?.value ?? 0) !== 0"
      align="right"
      prefix="€"
    >
    </snelstart-ui-number-form-control>
    <snelstart-ui-number-form-control
      formControlName="voorlopigeAanslagZvw"
      label="Voorlopige aanslag(en) ZVW {{ (incomeTaxEntity$ | async)?.year}}"
      id="voorlopigeAanslagZvw"
      class="custom-input-250"
      [decimals]="0"
      align="right"
      prefix="€"
    >
    </snelstart-ui-number-form-control>
  </form>
}
